import React from "react";
import { withRouter } from "react-router-dom";
import lanetalkLogo from "../../../shared/images/logo192.png";
import backImg from "../../../shared/images/arrow-back.svg";
import styles from "./styles.module.scss";
//import CustomizeButton from "./CustomizeButton/customizeButton";
import backArrowIcon from "../../../shared/images/back-arrow.svg";

const MainHeader = withRouter((props) => {
  const {
    back,
    showMenu,
    goToBack,
    className,
    toggleMenu = () => {},
    viewName,
    backArrow,
  } = props;
  return (
    <div className={`${styles.topBar} ${className && className}`}>
      <span className={styles.centerRowVertically}>
        {back && (
          <span className={styles.back} onClick={goToBack}>
            <img src={backImg} alt="back" />
          </span>
        )}
        <img
          src={lanetalkLogo}
          className={styles.lanetalkFullLogo}
          alt="Lanetalk Logo"
        />
        <span className={styles.textLogo}>Lanetalk</span>
      </span>

      <div className={styles.viewName}>
        {backArrow && (
          <span className={styles.back} onClick={goToBack}>
            <img src={backArrowIcon} alt="back" />
          </span>
        )}
        <span className={styles.textLogo} style={{ textShadow: "none" }}>
          {viewName}
        </span>
      </div>

      {/* {customizeAdd && <CustomizeButton />} */}
      {showMenu && (
        <div
          className={`${styles.centerRowVertically} ${styles.containerMenu}`}
          onClick={toggleMenu}
        >
          <span className={styles.iconMenu}>
            <span className={styles.rectangleMenu}></span>
            <span className={styles.rectangleMenu}></span>
          </span>
          <span className={styles.textLogo}>Menu</span>
        </div>
      )}
    </div>
  );
});

export default MainHeader;
